import Vue from 'vue'
import frag from '@/utils/frag'
Vue.directive('frag', frag)
